import React, { useState, useEffect, useContext } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { AdminAuthContext } from '../context/AdminAuthContext';

import Sidebar from '../components/ui/SideBar';
import TopBar from '../components/ui/TopBar';
import FloatingChatButton from '../components/ui/FloatingChatButton';

export default function MainLayout() {
  const location = useLocation();
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 1024);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);
  
  // Get user context to determine if it's admin or regular user
  const { admin } = useContext(AdminAuthContext);
  const { user } = useContext(AuthContext);
  
  const isAdminUser = !!admin;
  const contextClass = isAdminUser ? 'admin-context' : 'user-context';

  // Effect per gestire il resize
  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth >= 1024);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Effect per debug del routing
  useEffect(() => {
    console.log('Current location:', location.pathname);
  }, [location]);

  // Effect per scroll al top ad ogni cambio pagina
  useEffect(() => {
    const mainElement = document.querySelector('.main-content-scrollable');
    if (mainElement) {
      mainElement.scrollTo(0, 0);
    }
  }, [location.pathname]);

  // Rotte su cui NON vogliamo sidebar/topbar
  const hideNavOnPaths = ['/login2', '/admin/login'];
  const showNav = !hideNavOnPaths.includes(location.pathname);

  return (
    <div className={`flex h-screen w-full bg-light-surface dark:bg-dark-surface overflow-hidden ${contextClass}`}>
      {showNav && (
        <>
          <Sidebar
            isCollapsed={isCollapsed}
            setIsCollapsed={setIsCollapsed}
            isMobileMenuOpen={isMobileMenuOpen}
            setIsMobileMenuOpen={setIsMobileMenuOpen}
          />

          {/* Overlay per mobile */}
          {isMobileMenuOpen && (
            <div 
              className="fixed inset-0 bg-black/50 z-30 lg:hidden"
              onClick={() => setIsMobileMenuOpen(false)}
            />
          )}
        </>
      )}

      {/* CONTENUTO PRINCIPALE */}
      <div 
        className="flex flex-col flex-1 h-screen overflow-hidden bg-light-surface dark:bg-dark-surface ransition-all duration-300"
        style={{
          marginLeft: showNav && isDesktop ? (isCollapsed ? '5rem' : '18rem') : '0',
        }}
      >
        {showNav && (
          <TopBar
            isCollapsed={isCollapsed}
            isMobileMenuOpen={isMobileMenuOpen}
            setIsMobileMenuOpen={setIsMobileMenuOpen}
          />
        )}

        {/* CONTENUTO con scrollbar */}
        <main
          className="flex-1 overflow-y-auto overflow-x-hidden mt-16 bg-light-surface dark:bg-dark-surface main-content-scrollable relative"
        >
          <div className="p-4 min-h-full">
            <Outlet /> 
          </div>

          {/* Floating Chat Button - solo per utenti user (non admin) */}
          {user && !isAdminUser && <FloatingChatButton />}
        </main>
      </div>
    </div>
  );
}